import { render } from "./spotcheck-count.vue?vue&type=template&id=9a1162c6&scoped=true"
import script from "./spotcheck-count.vue?vue&type=script&lang=js"
export * from "./spotcheck-count.vue?vue&type=script&lang=js"

import "./spotcheck-count.vue?vue&type=style&index=0&id=9a1162c6&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1162c6"]])

export default __exports__